import { render, staticRenderFns } from "./AccountStatement.vue?vue&type=template&id=b0c2aacc&scoped=true&"
import script from "./AccountStatement.vue?vue&type=script&lang=js&"
export * from "./AccountStatement.vue?vue&type=script&lang=js&"
import style0 from "./AccountStatement.vue?vue&type=style&index=0&id=b0c2aacc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c2aacc",
  null
  
)

export default component.exports